import { render, staticRenderFns } from "./LiongardTabber.vue?vue&type=template&id=76af8518&"
import script from "./LiongardTabber.vue?vue&type=script&lang=js&"
export * from "./LiongardTabber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports